<fieldset [formGroup]="checkboxFormGroup" class="mb-4">
    <legend class="text-base">
        <apcam-translation [model]="inputConfig.label" />
    </legend>
    @for (
        option of inputConfig.options;
        track option.label.translations[defaultLang]
    ) {
        <mat-checkbox
            [formControlName]="option.label.translations[defaultLang]"
            class="block!">
            <apcam-translation [model]="option.label" />
        </mat-checkbox>
    }
</fieldset>
